/**
 * 获取地址栏参数 （非路由传参）
 * @param name
 * @returns
 */
export function getUrlKey(name, url) {
  const reg_rule = new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
    url || location.href
  ) || [null, ""];
  return decodeURIComponent(reg_rule[1].replace(/\+/g, "%20")) || null;
}

/**
 *
 * 获取当前下载地址
 * @param data1 马来
 * @param data2 欧洲
 * @returns
 */
export function getCurrentHost(data1, data2) {
  let {
    NODE_ENV,
    VUE_APP_ML_HOST,
    VUE_APP_API_DOWNLOAD,
    VUE_APP_EU_API_DOWNLOAD,
  } = process.env;
  if (!data1) {
    data1 = VUE_APP_API_DOWNLOAD;
    data2 = VUE_APP_EU_API_DOWNLOAD;
  }
  let hostName = window.location.hostname;
  return NODE_ENV === "production" && hostName != VUE_APP_ML_HOST
    ? data2
    : data1;
}
